// Compatible avec defer et DOMContentLoaded
(function init() {
  // Ne pas exécuter dans l'éditeur Gutenberg
  const isEditor =
    document.body?.classList.contains("wp-admin") &&
    (document.body.classList.contains("block-editor-page") ||
      document.querySelector(".block-editor__container"));
  if (isEditor) return;

  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  const slugify = (str) =>
    (str || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  // ---- Flèches de scroll (mobile) ----
  function setupScrollArrows(root, scroller) {
    if (!root || !scroller) return;
    if (root.__tabsWithArrows) return;
    root.__tabsWithArrows = true;

    const btnPrev = document.createElement("button");
    btnPrev.className = "tab-scroll-btn is-left";
    btnPrev.type = "button";
    btnPrev.setAttribute("aria-label", "Scroll left");
    btnPrev.setAttribute("aria-hidden", "true");
    btnPrev.textContent = "\u2039";

    const btnNext = document.createElement("button");
    btnNext.className = "tab-scroll-btn is-right";
    btnNext.type = "button";
    btnNext.setAttribute("aria-label", "Scroll right");
    btnNext.setAttribute("aria-hidden", "true");
    btnNext.textContent = "\u203A";

    const setVisible = (el, visible) => {
      el.style.setProperty("display", visible ? "flex" : "none", "important");
      el.setAttribute("aria-hidden", visible ? "false" : "true");
      el.disabled = !visible;
    };
    setVisible(btnPrev, false);
    setVisible(btnNext, false);

    root.appendChild(btnPrev);
    root.appendChild(btnNext);

    function findSolidBg(el) {
      let cur = el;
      while (cur && cur !== document.documentElement) {
        const bg = getComputedStyle(cur).backgroundColor;
        if (bg && bg !== "rgba(0, 0, 0, 0)" && bg !== "transparent") return bg;
        cur = cur.parentElement;
      }
      return "transparent";
    }
    root.style.setProperty("--tabs-bg", findSolidBg(root));

    const scrollAmount = () => Math.max(160, Math.round(scroller.clientWidth * 0.8));
    btnPrev.addEventListener("click", (e) => {
      e.preventDefault();
      scroller.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
    });
    btnNext.addEventListener("click", (e) => {
      e.preventDefault();
      scroller.scrollBy({ left: scrollAmount(), behavior: "smooth" });
    });

    function positionArrows() {
      const rRoot = root.getBoundingClientRect();
      const rBar = scroller.getBoundingClientRect();
      const centerY = rBar.top - rRoot.top + rBar.height / 2;
      btnPrev.style.top = `${centerY}px`;
      btnNext.style.top = `${centerY}px`;
    }

    function update(initialPass = false) {
      if (!isMobile()) {
        root.classList.remove("tabs-has-overflow", "tabs-at-start", "tabs-at-end");
        setVisible(btnPrev, false);
        setVisible(btnNext, false);
        return;
      }

      // Si l'élément n'a pas encore de dimensions (caché dans un modal fermé par ex.),
      // on évite de prendre des décisions sur des valeurs à 0.
      if (scroller.clientWidth === 0) {
        return;
      }

      if (initialPass) scroller.scrollLeft = 0;

      positionArrows();
      scroller.getBoundingClientRect(); // force reflow

      const hasOverflow = scroller.scrollWidth > scroller.clientWidth + 2;
      root.classList.toggle("tabs-has-overflow", hasOverflow);

      if (!hasOverflow) {
        root.classList.remove("tabs-at-start", "tabs-at-end");
        setVisible(btnPrev, false);
        setVisible(btnNext, false);
        return;
      }

      const EPS = 4;
      const sr = scroller.getBoundingClientRect();
      const firstEl = scroller.firstElementChild;
      const lastEl = scroller.lastElementChild;

      let atStartByEdges = true;
      let atEndByEdges = true;

      if (firstEl) {
        const fr = firstEl.getBoundingClientRect();
        atStartByEdges = fr.left >= sr.left - EPS;
      }
      if (lastEl) {
        const lr = lastEl.getBoundingClientRect();
        atEndByEdges = lr.right <= sr.right + EPS;
      }

      const atStart = Math.abs(scroller.scrollLeft) <= EPS || atStartByEdges;
      const atEnd =
        scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - EPS ||
        atEndByEdges;

      root.classList.toggle("tabs-at-start", atStart);
      root.classList.toggle("tabs-at-end", atEnd);

      setVisible(btnPrev, !atStart);
      setVisible(btnNext, !atEnd);
    }

    scroller.addEventListener("scroll", () => update(false), { passive: true });
    window.addEventListener("resize", () => update(false));

    const ro = new ResizeObserver(() => {
      positionArrows();
      update(false);
    });
    ro.observe(scroller);

    root.__updateTabArrows = () => update(false);
    root.__refreshTabArrows = () => {
      // Re-pick le background (utile si le tab a été déplacé dans un modal)
      root.style.setProperty("--tabs-bg", findSolidBg(root));
      update(true);
      requestAnimationFrame(() => update(false));
    };

    update(true);
    requestAnimationFrame(() => update(true));
    window.addEventListener("load", () => update(false));
  }

  // ---- Init sur chaque bloc ----
  document.querySelectorAll(".wp-block-brblocks-tabs").forEach((tabBlock) => {
    const buttonsContainer = tabBlock.querySelector("[data-tabs='buttons']");
    const contentsContainer = tabBlock.querySelector("[data-tabs='contents']");
    if (!buttonsContainer || !contentsContainer) return;

    // Enfants directs uniquement (évite de capturer des éléments imbriqués)
    const contents = Array.from(contentsContainer.children).filter((el) =>
      el.classList.contains("tab-content")
    );
    if (!contents.length) return;

    // Récupère le titre de chaque tab-content (avec fallback si absent)
    const titles = contents.map(
      (c, i) => c.querySelector(".tab-title") || { textContent: `Tab ${i + 1}`, getAttribute: () => null }
    );

    const shouldUpdateHash = tabBlock.dataset.updateHash !== "0";
    buttonsContainer.setAttribute("role", "tablist");

    const anchors = [];
    const anchorToIndex = {};
    const used = new Set();

    titles.forEach((titleEl, index) => {
      const button = document.createElement("button");
      button.className = "tab-button";
      button.setAttribute("role", "tab");
      button.type = "button";
      button.innerHTML = titleEl.textContent || `Tab ${index + 1}`;

      let anchor =
        titleEl.getAttribute("data-anchor") ||
        slugify(titleEl.textContent || `Tab ${index + 1}`) ||
        `tab-${index + 1}`;

      const base = anchor;
      let inc = 2;
      while (used.has(anchor)) anchor = `${base}-${inc++}`;
      used.add(anchor);

      const btnId = `tab-btn-${anchor}`;
      button.id = btnId;
      button.setAttribute("aria-controls", `tab-content-${anchor}`);

      contents[index].id = `tab-content-${anchor}`;
      contents[index].setAttribute("role", "tabpanel");
      contents[index].setAttribute("aria-labelledby", btnId);

      anchors[index] = anchor;
      anchorToIndex[anchor] = index;

      button.addEventListener("click", () => {
        showIndex(index, { updateHash: true, focusButton: true });
      });

      buttonsContainer.appendChild(button);
    });

    setupScrollArrows(tabBlock, buttonsContainer);

    buttonsContainer.addEventListener("keydown", (e) => {
      const buttons = Array.from(tabBlock.querySelectorAll(".tab-button"));
      const currentIndex = buttons.findIndex((b) => b.classList.contains("active"));
      if (currentIndex < 0) return;

      let next = null;
      switch (e.key) {
        case "ArrowRight":
          next = (currentIndex + 1) % buttons.length;
          break;
        case "ArrowLeft":
          next = (currentIndex - 1 + buttons.length) % buttons.length;
          break;
        case "Home":
          next = 0;
          break;
        case "End":
          next = buttons.length - 1;
          break;
        default:
          return;
      }
      e.preventDefault();
      showIndex(next, { updateHash: true, focusButton: true });
    });

    function showIndex(index, opts = { updateHash: false, focusButton: false }) {
      contents.forEach((c, i) => {
        const active = i === index;
        c.style.display = active ? "block" : "none";
        c.setAttribute("aria-hidden", active ? "false" : "true");
      });

      const buttons = tabBlock.querySelectorAll(".tab-button");
      buttons.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle("active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
        btn.setAttribute("tabindex", active ? "0" : "-1");
      });

      const current = tabBlock.querySelector(".tab-button.active");
      if (opts.focusButton && current) {
        current.focus({ preventScroll: true });
      }

      if (current && buttonsContainer && isMobile()) {
        const cr = current.getBoundingClientRect();
        const sr = buttonsContainer.getBoundingClientRect();
        const pad = 8;
        if (cr.left < sr.left) {
          buttonsContainer.scrollBy({ left: cr.left - sr.left - pad, behavior: "smooth" });
        } else if (cr.right > sr.right) {
          buttonsContainer.scrollBy({ left: cr.right - sr.right + pad, behavior: "smooth" });
        }
      }

      if (opts.updateHash && shouldUpdateHash) {
        const a = anchors[index];
        if (a) history.replaceState(null, "", `#${a}`);
      }

      if (typeof tabBlock.__updateTabArrows === "function") {
        tabBlock.__updateTabArrows();
      }
    }

    function activateFromHash() {
      const raw = (location.hash || "").replace(/^#/, "");
      if (!raw) return false;

      if (raw in anchorToIndex) {
        showIndex(anchorToIndex[raw], { updateHash: false, focusButton: false });
        return true;
      }

      const m = raw.match(/^tab-(\d+)$/i);
      if (m) {
        const i = Math.max(0, parseInt(m[1], 10) - 1);
        if (i >= 0 && i < contents.length) {
          showIndex(i, { updateHash: false, focusButton: false });
          return true;
        }
      }
      return false;
    }

    const defaultAttr = parseInt(tabBlock.dataset.defaultActive || "0", 10) || 0;
    const usedHash = activateFromHash();

    if (!usedHash) {
      const initialIndex = defaultAttr >= 0 && defaultAttr < contents.length ? defaultAttr : 0;
      showIndex(initialIndex, { updateHash: false, focusButton: false });
    } else if (!shouldUpdateHash) {
      history.replaceState(null, "", location.pathname + location.search);
    }

    window.addEventListener("hashchange", activateFromHash);
  });

  /* =========================================
     EXPOSE GLOBAL REFRESH
     Permet à d'autres scripts (ex: cards-modal)
     de re-calculer les tabs après un changement
     de visibilité ou de parent DOM.
  ========================================= */
  window.brBlocksRefreshTabs = function (scope) {
    const root = scope || document;
    root.querySelectorAll(".wp-block-brblocks-tabs").forEach((tabBlock) => {
      if (typeof tabBlock.__refreshTabArrows === "function") {
        tabBlock.__refreshTabArrows();
      } else if (typeof tabBlock.__updateTabArrows === "function") {
        tabBlock.__updateTabArrows();
      }
    });
  };
})();